import * as React from "react";
import './SignUpForm.css'
import Icon from "../../../../components/Icon/Icon";
import {Redirect, RouteComponentProps} from "react-router";
import NavigationConstants from "../../../Navigation/NavigationConstants";

const PAGES_WITH_CLOSE_BUTTON = [NavigationConstants.addCoverage, NavigationConstants.managePlan, NavigationConstants.manageLoan, NavigationConstants.payments];

interface IProps extends RouteComponentProps<any>{
    isMobilePayment: boolean;
    isPayment: boolean
}

interface ILocalState {
    navigate: boolean;
    navigateTarget: string
}

export default class SignUpForm  extends React.Component<
    IProps, ILocalState
    > {
    public state: ILocalState = {
        navigate: false,
        navigateTarget: ''
    }
    public render() {
        const {children, isMobilePayment, isPayment} = this.props;
        const paymentMobile = isMobilePayment ? "mobile-payment-layout" : "";
        const payment = isPayment ? " payment-layout" : "";
        {
            return this.state.navigate ? <Redirect to={this.state.navigateTarget}/> :
                <>
                    {this.renderCloseButtonIfNeeded()}
                    <div className={"form-layout " + paymentMobile + payment}>
                        <>{children}</>
                    </div>
                </>
        }
    }

    public renderCloseButtonIfNeeded() {
        const pathName = this.props.location.pathname;
        if(PAGES_WITH_CLOSE_BUTTON.includes(pathName)){
            return (<div className="close-btn-navigation" onClick={this.closeForm}>
                <Icon icon={"exitBtn"}/>
            </div>);
        }
        return null;
    }

    private closeForm = () => {
        const newState = this.state;
        newState.navigate = true;
        newState.navigateTarget = this.getNavigationTarget();
        this.setState(newState);
    }

    private getNavigationTarget = () => {
        const pathName = this.props.location.pathname;
        switch (pathName) {
            case NavigationConstants.payments:
            case NavigationConstants.managePlan:
            case NavigationConstants.addCoverage: return NavigationConstants.myAccount;
            default: return ""
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/components/SignUpForm/SignUpForm.tsx